/* eslint-disable */

import Vue from 'vue';
import Router from 'vue-router';
import firebase from 'firebase';
import store from '@/lib/vuex/Store';
import DashboardView from '@/views/dashboard';
import ProjectView from '@/views/project';
import AccountView from '@/views/account';
import AcceptInviteView from '@/views/accept-invite';
import LoginView from '@/views/login';
import ForgotView from '@/views/forgot';
import AdminDashboard from '@/views/admin-dashboard';

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/login/:redirect?',
            name: 'login',
            props: true,
            component: LoginView
        },
        {
            path: '/forgot',
            name: 'forgot',
            props: true,
            component: ForgotView
        },
        {
            path: '/',
            name: 'home',
            component: DashboardView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: DashboardView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/admin',
            name: 'admin',
            component: AdminDashboard,
            meta: {
                requiresAuth: true,
                requiresAdmin: true
            }
        },  
        {
            path: '/account',
            name: 'account',
            component: AccountView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/project/:id',
            name: 'project',
            component: ProjectView,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/project/:id/version/:version',
            name: 'projectVersion',
            component: ProjectView,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/invite/:id',
            name: 'acceptInvite',
            component: AcceptInviteView,
            props: true,
            meta: {
                requiresAuth: true
            }
        }
    ],
});

router.beforeEach((to, from, next) => {
    let currentUser = firebase.auth().currentUser;
    let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    let requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);

    if (requiresAdmin) {
        if (!currentUser) {
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            });
        } else {
            firebase.database().ref(`users/${currentUser.uid}`).once('value', (snap) => {
                const user = snap.val();
                if (user && user.admin) {
                    next();    
                } else {
                    next('/');
                }
            });
        }
        return;
    }

    if (!currentUser && requiresAuth) {
        next({
            path: '/login',
            query: { redirect: to.fullPath }
        });
        return;
    }

    next();
});

export default router;



// WEBPACK FOOTER //
// ./sample/router/index.js